// ******************** Colors ********************
const red = `#5a1b12`;
const yellow = `#9D7248`;
const black = `#323232`;
const blue = `#2E5761`;
const linkBlue = `#305791`;
const green = `#367647`;
const grey = `#696969`;
// ******************** Initialization Variables ********************
const cartButtonInitializationValue = "SELECT SIZE TO ADD TO CART";
const reamazeShippingStyle = `cursor: pointer; padding-left: 0; color: ${linkBlue};`;
const shippingPreFixTextList = [
  { prefixCheck: "preorder", reamazeLink: "/articles/pre-ordering-an-out-of-stock-product" },
  { prefixCheck: "instock", reamazeLink: "/articles/when-will-an-order-be-delivered" }
];
const selectedVariantQuery = `[id*="variantchange_selectedonload_"]`;
// ******************** Logic Options ********************
// Toggles additional logic used to hide cart button based on vendor, costs, etc.
const utilizeAdditionalCartButtonLogic = true;
// ******************** CSS Classes ********************
const backOrderLabel_class = "product__label fs-body-100";
// ******************** Variables ********************
const openNewTab = `target="_blank" rel="noopener noreferrer"`;
const buttonId_notifyMe = "BIS_trigger";
let notify_storedButton = null;
let notify_parent = null;
let notify_nextSibling = null;
// Variables to control language displayed in add to cart button
const cartText_quanityAboveZero = "Add To Cart";
const cartText_quanityAtOrBelowZeroContinue = "Pre-Order";
const cartText_quanityAtOrBelowZeroDeny = "Sold Out"; // Note: Also utilized when item has purchase ability removed.
// Prefixes displyed in for cart availability
const backOrder_prefixes = {
  madeToOrder: "Made To Order", inStock: "In Stock", preOrder: "Pre-Order", soldOut: "Sold Out"
};
// Objects and default used for instock shipping times with cart availability
const inStockShippingDefaultDate = "2 - 5 Days";
const inStockShippingVendorList = [
  {
    returnString: "1 - 2 Days", vendors: [
      "Oriental Weavers", "Auskin", "Unique Loom", "Bashian", "Teebaud",
      "Anji Mountain", "Ancient Boundaries", "Kalaty", "Chandra", "KAS", "Safavieh"]
  },
  { returnString: "7 - 14 Days", vendors: ["Trans Ocean", "Art Effects", "Joy Carpets"] }
];
// Objects and default used for Made to Order shipping times with cart availability.
const madeToOrder_defaultDate = "2 - 6 Weeks";
const madeToOrder_vendorList = [
  { vendors: ["Karastan"], defaultValue: "4 - 6 Weeks", origin: null },
  { vendors: ["Dalyn", "Piper Looms"], defaultValue: "2 - 5 Days", origin: { india: "16 Weeks", china: "14 Weeks" } }
];
// Links provided to freepad anchor tags 
const freePadLinks = {
  standard: `https://incrediblerugsanddecor.com/products/jazzy-floors-non-slip-rug-pad`,
  standardSizes: [
    { size: `1' 8'' X 3' 4'' Rectangle`, variant: `variant=20815692870` }, { size: `1'11'' X 7' 6'' Runner`, variant: `variant=32452879750` },
    { size: `3' 4'' X 5' 0'' Rectangle`, variant: `variant=20815694854` }, { size: `1'10'' X 11' 8'' Runner`, variant: `variant=20815694278` },
    { size: ` 4' 8'' X 7' 6'' Rectangle`, variant: `variant=20815695174` }, { size: `5' 6'' Round`, variant: `variant=20815696134` },
    { size: `5' 5'' X 7'10'' Rectangle`, variant: `variant=32452881414` }, { size: `7' 6'' Round`, variant: `variant=20815696902` },
    { size: `7' 6'' X 10' 8'' Rectangle`, variant: `variant=20815697862` }, { size: `8' 6'' X 11' 4'' Rectangle`, variant: `variant=20815698374` },
    { size: `9' 6'' X 13' 4'' Rectangle`, variant: `variant=20815699590` }, { size: `11' 8'' X 14' 8'' Rectangle`, variant: `variant=20815699718` }
  ],
  premium: `https://incrediblerugsanddecor.com/products/karastan-pet-proof-rug-pad-thin`,
  premiumSizes: [
    { size: `2' x 4' Rectangle`, variant: `variant=20815655942` }, { size: `2' X 8' Runner`, variant: `variant=20815657030` },
    { size: `2' x 12' Runner`, variant: `variant=31451496906823` }, { size: `4' x 6' Rectangle`, variant: `variant=20815657670` },
    { size: `5' x 7' Rectangle`, variant: `variant=40522345414856` }, { size: `5' x 8' Rectangle`, variant: `variant=20815658566` },
    { size: `6' Round`, variant: `variant=20815657862` }, { size: `6' x 9' Rectangle`, variant: `variant=20815658822` },
    { size: `8' Round`, variant: `variant=20815659462` }, { size: `8' x 10' Rectangle`, variant: `variant=40522347708616` },
    { size: `8' x 11' Rectangle`, variant: `variant=20815660102` }, { size: `9' x 12' Rectangle`, variant: `variant=20815661446` },
    { size: `10' x 14' Rectangle`, variant: `variant=20815663558` }, { size: `12' x 15' Rectangle`, variant: `variant=20815664006` },
    { size: `12' x 18' (2 pieces)`, variant: `variant=40726366093512` }
  ]
};
// Style for conditionally rendered anchor tags
const anchorStyle = `text-decoration: underline; color: ${blue}; !important`;
// ******************** DEFINED TYPES ********************
function prefixObject(prefix, value, color, hidePreorder) {
  return { prefix: prefix, value: value, color: color, hidePreorder: hidePreorder };
}
// ******************** SHARED FUNCTIONS ********************
// Retrieves the matching product variant from embedded JSON data based on the URL parameter
function getVariantOnLoad() {
  try {
    var recordsElement = document.querySelectorAll('div[id^="variantchange_productData"]');
    if (!recordsElement || recordsElement.length === 0) return null;
    var records = JSON.parse(recordsElement[0].innerText);
    if (!records || !records.variants) return null;
    records = records.variants;
    var queryString = window.location.search || "";
    var variantIdMatch = queryString.match(/[?&]variant=(\d+)/);
    var variantId = variantIdMatch ? parseInt(variantIdMatch[1], 10) : NaN;
    if (Object.prototype.toString.call(records) === "[object Array]" && !isNaN(variantId)) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].id === variantId) return records[i];
      }
      return null;
    } else { return null; }
  } catch (err) {
    console.log(err);
    return null;
  }
}
// Checks if any keys from `objectKeys` exist in the provided `valueSet`
function checkObjectKeys(valueSet, objectKeys) {
  // Helper: determines if any element in listToCheck contains an element from list
  function checkIfInArray(list, listToCheck) {
    for (var i = 0; i < listToCheck.length; i++) {
      for (var j = 0; j < list.length; j++) {
        if (listToCheck[i].indexOf(list[j]) !== -1) return true;
      }
    }
    return false;
  }
  return checkIfInArray(objectKeys, Object.keys(valueSet));
}
// Checks if the given search string exists inside any string element of an array
function checkIfArrayIncludesStringInElement(search, array) {
  for (var i = 0; i < array.length; i++) 
    if (typeof array[i] === "string" && array[i].indexOf(search) !== -1) return true;
  return false;
}
// Validates whether a string is valid JSON
function checkIfValidJson(string) {
  try { JSON.parse(string); return true; } catch (err) { return false; }
}
// Retrieves the selected product variant from the DOM and parses it as JSON
function getSelectedVariant() {
  try {
    var variantSelected = document.querySelectorAll(selectedVariantQuery);
    if (variantSelected.length === 0) return null;
    variantSelected = variantSelected[0].innerHTML;
    return checkIfValidJson(variantSelected) ? JSON.parse(variantSelected) : null;
  } catch (err) {
    console.warn(err);
    return null;
  }
}
// SELECT SIZE TO ADD TO CART
// Initializes the Add to Cart button to a disabled state with default styling
function instantiateButton() {
  var productCartButton = document.getElementById("productCartButton");
  var productCartButtonSpan = document.getElementById("productCartButtonSpan");
  if (!productCartButton) return;

  setButtonState(productCartButton, false, "not-allowed", 0.6);
  if (productCartButtonSpan) productCartButtonSpan.textContent = "SELECT SIZE TO ADD TO CART";
}
// Disables the Add to Cart button with standard styling
function disableSaleButton() {
  var productCartButton = document.getElementById("productCartButton");
  if (!productCartButton) return;

  setButtonState(productCartButton, false, "not-allowed", 0.6);
}
// Enables the Add to Cart button with optional color for available state
function enableSaleButton(color) {
  var productCartButton = document.getElementById("productCartButton");
  if (!productCartButton) return;
  setButtonState(productCartButton, true, "pointer", 1.0, color);
}
// Helper function to reduce repeated code for setting button states
function setButtonState(button, isEnabled, cursorStyle, opacity, backgroundColor) {
  button.disabled = !isEnabled;
  button.style.pointerEvents = isEnabled ? "auto" : "none";
  button.style.opacity = opacity;
  button.setAttribute("aria-disabled", isEnabled ? "false" : "true");
  button.style.cursor = cursorStyle;
  if (backgroundColor) button.style.backgroundColor = backgroundColor;
}
// ******************** GET METAFIELDS FOR product:variant-change  ********************
// Safely retrieves the text content of a DOM element by ID, returns null if not found
function getLoadedDataFromDiv(id) {
  if (typeof id !== 'string' || id.trim() === '') {
    console.warn('Invalid ID provided to getLoadedDataFromDiv');
    return null;
  }
  var element = document.getElementById(id);
  if (!element) {
    console.warn(`Element with ID "${id}" not found`);
    return null;
  }
  var text = element.textContent || element.innerText || '';
  return text.trim();
}
// Maps each value from a CSV string to the corresponding variant object by key
function associateKeyToMetafield(objectList, key, valueList) {
  try {
    valueList = valueList.split(',');
    var it = 0;
    for (var property in objectList) {
      if (valueList[it]) valueList[it] = valueList[it].replace(/\\\//g, '/');
      objectList[property][key] = valueList[it] || '';
      it++;
    }
    return objectList;
  } catch (err) {
    console.warn('Function "associateKeyToMetafield":' + err.message);
    return objectList;
  }
}
// Associates backorder metafields with each variant for a given parent product ID
function associateMetafields(metafieldsById, parentId) {
  var backOrders = getLoadedDataFromDiv('variantchange_variantMetafieldBackorder_' + parentId) || '';
  backOrders = backOrders.replace(/"/g, '');
  metafieldsById = associateKeyToMetafield(metafieldsById, 'backorder', backOrders);
  return metafieldsById;
}
// Finds and returns the parent product object that contains the specified variant ID
function findParentId(variantId) {
  try {
    var parentIds = document.querySelectorAll('div[id^="variantchange_productData"]');
    for (var it = 0; it < parentIds.length; it++) {
      var rawData = getLoadedDataFromDiv(parentIds[it].id);
      if (!rawData) continue;
      var currentProduct;
      try { currentProduct = JSON.parse(rawData); } 
      catch (err) {
        console.warn('Could not parse JSON for', parentIds[it].id, err);
        continue;
      }
      if (hasVariant(currentProduct.variants, variantId)) return currentProduct;
    }
    return null;
  } catch(err){
    console.log('Function "findParentId": ' + err.message );
    return null;
  }
}
// Returns the variant object from a list by its ID, or null if not found
function getVariantById(variantList, id) {
  try {
    for (var property in variantList) 
      if (variantList.hasOwnProperty(property) && String(property) === String(id)) return variantList[property];
    return null;
  } catch (err) {
    console.warn(err.message);
    return null;
  }
}
// Checks if a variant with a given ID exists in the variants array
function hasVariant(variants, variantId) {
  try {
    if (!variants || !variants.length) return false;
    for (var i = 0; i < variants.length; i++) {
      var current = variants[i];
      var currentId = (current && current.id != null) ? String(current.id) : null;
      if (currentId !== null && currentId === String(variantId)) return true;
    }
    return false;
  } catch (err) {
    console.warn('Function "hasVariant": ' + err.message);
    return false;
  }
}
// Retrieves metafields for a variant by ID from loaded page data
function getMetafields(id, parentId) {
  try {
    var rawData = getLoadedDataFromDiv('variantchange_variantMetafieldId_' + parentId) || '';
    var metafieldIds = rawData.replace(/"/g, '').split(',');
    var metafieldsById = {};
    var i;
    var validIds = [];
    for (i = 0; i < metafieldIds.length; i++) {
      if (metafieldIds[i] && metafieldIds[i].trim() !== '') { validIds.push(metafieldIds[i]); }
    }
    if (validIds.length > 0) {
      for (i = 0; i < validIds.length; i++) { metafieldsById[validIds[i]] = {}; }
      metafieldsById = associateMetafields(metafieldsById, parentId);
      return getVariantById(metafieldsById, id);
    } else { return {}; }
  } catch (err) {
    console.warn('Function "getMetafields": ' + err.message);
    return null;
  }
}
// ******************** FIND MATCHING RUG SIZE  ********************
// Converts a size string like "5' 4'' Round" into numeric inches and identifies if it's round
function convertSize(string) {
  // Converts a single foot/inch string to total inches
  function convertToInches(string) {
    var returnValue = 0;
    string = string.replace(/''/g, ''); // IE11 compatible replaceAll
    string = string.split("'");
    returnValue += parseInt(string[0], 10) * 12;
    if (typeof string[1] !== "undefined" && string[1] !== null) returnValue += parseInt(string[1], 10);
    return returnValue;
  }
  // Splits a size string into width and length using "X" as separator
  function splitTag(string, index) {
    string = string.substr(index, string.lastIndexOf("'") + 1);
    return string.split('X');
  }
  // Ensures each dimension has inches, appending "0''" if missing
  function addZero(array) {
    for (var i = 0; i < array.length; i++) if (array[i].indexOf("''") === -1) array[i] = array[i] + " 0''";
    return array;
  }
  // Converts a size string into an array of inches and determines if it's round
  function tokenizeSize() {
    var isRound = false;
    var inches = [];
    var getMeasurementFromSize = splitTag(string, 0);
    getMeasurementFromSize = addZero(getMeasurementFromSize);
    if (getMeasurementFromSize.length === 1) {
      inches = [convertToInches(getMeasurementFromSize[0]), 0];
      isRound = true;
    } else { inches = [convertToInches(getMeasurementFromSize[0]), convertToInches(getMeasurementFromSize[1])]; }
    return { size: inches, isRound: isRound };
  }
  return tokenizeSize();
}
var stringTest = "5' 4'' Round";
// Finds the closest sample pad to a target size, considering round vs. non-round pads
function getClosestSampleSize(tokenizedSize, pads) {
  // Filters pads by whether they are round or not
  function removeUnqualifiedPads(pads, isRound) {
    var returnPads = [];
    for (var i = 0; i < pads.length; i++) {
      var currentItem = pads[i];
      if (isRound === true && currentItem.size.toLowerCase().indexOf('round') >= 0) returnPads.push(currentItem);
      if (isRound === false && currentItem.size.toLowerCase().indexOf('round') === -1) returnPads.push(currentItem);
    }
    return returnPads;
  }
  // Converts pad sizes into numeric tokenized form
  function getTokenizedSampleSizes(sampleRecords) {
    var tokenizedSizes = [];
    for (var i = 0; i < sampleRecords.length; i++) {
      tokenizedSizes.push(convertSize(sampleRecords[i].size));
    }
    return tokenizedSizes;
  }
  // Finds the value in arr closest to x
  function findClosest(x, arr) {
    var minDiff = Infinity;
    var closestIndex = -1;
    for (var i = 0; i < arr.length; i++) {
      var diff = Math.abs(arr[i] - x);
      if (diff < minDiff) {
        minDiff = diff;
        closestIndex = i;
      }
    }
    return { value: arr[closestIndex], index: closestIndex };
  }
  // Extracts one dimension (width/length) from tokenized pads
  function getArray(tokenizedPads, arrayIndex) {
    var result = [];
    for (var i = 0; i < tokenizedPads.length; i++) result.push(tokenizedPads[i].size[arrayIndex]);
    return result;
  }
  // Counts how many times a value occurs in an array
  function countOccurrences(data, array) {
    var count = 0;
    for (var i = 0; i < array.length; i++) if (array[i] === data) count++;
    return count;
  }
  // Compares the target size to all pads and finds the closest
  function compareRecords(tokenizedSize, tokenizedPads) {
    var widthArray = getArray(tokenizedPads, 0);
    var closestWidth = findClosest(tokenizedSize.size[0], widthArray);
    return closestWidth.index;
  }
  // Main function to return the closest pad or null
  function getSize() {
    try {
      pads = removeUnqualifiedPads(pads, tokenizedSize.isRound);
      var tokenizedPads = getTokenizedSampleSizes(pads);
      var padIndex = compareRecords(tokenizedSize, tokenizedPads);
      if (padIndex !== null && typeof tokenizedPads[padIndex] !== "undefined") {
        var difference = Math.abs(tokenizedPads[padIndex].size[0] - tokenizedSize.size[0]);
        if (difference < 1020) return pads[padIndex];
      }
      return null;
    } catch (err) {
      console.warn('Function "getSize": ' + err.message);
      return null;
    }
  }
  return getSize();
}

// ******************** PROCESS BACKORDERS ********************
// ******************** [product:variant-change] 
// Validate date
function isValidDate(date) {
    return !isNaN(Date.parse(date));
}

function getCountryOfOrigin(tags) {
    try {
        if (!Array.isArray(tags)) return '';
        for (var i = 0; i < tags.length; i++) 
            if (typeof tags[i] === "string" && tags[i].indexOf('Origin_') >= 0) 
              return tags[i].replace('Origin_', '');
        return '';
    } catch (err) {
        console.warn('Function "getCountryOfOrigin": ' + err.message);
        return '';
    }
}

// Calculate difference in days
function calculateDateDifference(currentDate, targetDate) {
    const diffMs = targetDate - currentDate;
    return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
}

// Core logic to get backorder timeframe from raw date
function getBackorderTimeframeFromRawDate(rawDate, productOrigin, vendorName) {
    try {
        if (!isValidDate(rawDate)) return null;
        var parsedDate = new Date(rawDate);
        var currentDate = new Date();
        if (!(parsedDate > currentDate)) return null;
        var dateDifference = calculateDateDifference(currentDate, parsedDate);
        if (vendorName === 'Karastan' && productOrigin === 'Turkey') return "2 - 4 Weeks";
        if (dateDifference <= 10) return "1 Week";
        else if (dateDifference < 16) return "1 - 2 Weeks";
        else if (dateDifference < 23) return "2 - 3 Weeks";
        else if (dateDifference < 30) return "3 - 4 Weeks";
        else if (dateDifference < 45) return "4 - 6 Weeks";
        else if (dateDifference < 60) return "6 - 8 Weeks";
        else return rawDate;
    } catch (err) {
        console.warn('Function "getBackorderTimeframeFromRawDate": ' + err.message);
        return null;
    }
}

// Returns default shipping/backorder timeframe based on vendor
function getResultByVendor(vendorName) {
    try {
        if (typeof vendorName !== "string" || !vendorName.trim()) return "Chat for Date";
        var name = vendorName.trim().toLowerCase();
        var karastanMap = { "karastan": true, "american rug craftsmen": true, "mohawk home": true, "mohawk": true };
        var kalatyMap = { "kalaty": true, "ancient boundaries": true, "k2": true, "n natori": true };
        if (karastanMap[name]) return "2 - 4 Weeks";
        if (kalatyMap[name]) return "1 - 2 Days";
        return "Chat for Date";
    } catch(err){
        console.warn('Function "getResultByVendor": ' + err.message);
        return "Chat for Date";
    }
}

// Wrapper to match old function name
function getBackorderTimeframe(rawData, vendorName, productOrigin) {
    const timeframe = getBackorderTimeframeFromRawDate(rawData, productOrigin, vendorName);
    if (timeframe !== null) return timeframe;
    return getResultByVendor(vendorName);
}
// Returns a backorder timeframe from raw data or vendor default
function getBackorderStatus(variantBackOrder, variant, tags, productDetails) {
    for (var i = 0; i < tags.length; i++) if (tags[i].indexOf('Made To Order') >= 0) return "Made To Order";
    if (variant.inventory_quantity > 0 && variantBackOrder === "Sold Out") variantBackOrder = '';
    if (variantBackOrder === "" || variantBackOrder == null) variantBackOrder = '';
    if (variantBackOrder.toLowerCase && variantBackOrder.toLowerCase() === "sold out") return "Sold Out";
    if (variantBackOrder === "") return "In stock";
    var countryOrigin = getCountryOfOrigin(tags);
    var backOrderTime = getBackorderTimeframe(variantBackOrder, productDetails.vendor, countryOrigin);
    if (backOrderTime != null) return backOrderTime;
    if (tags.indexOf("MFD-HIDE") >= 0) return "Sold Out";
    if (variant.inventory_quantity <= 0) return "Sold Out";
    if (variant.title.toLowerCase().indexOf('custom size') >= 0) return "Made to Order";
    return variantBackOrder;
}
// Returns estimated ship time for made-to-order products based on vendor or tags
function madeToOrderCalculation(vendor, tags) {
  tags = Array.isArray(tags) ? tags : [];
  const origin = (getCountryOfOrigin(tags) || "").toLowerCase();
  vendor = vendor || "";
  for (var t = 0; t < tags.length; t++) {
    if (typeof tags[t] === "string" && tags[t].indexOf("Braided") !== -1) return "2 - 4 Weeks";
  }
  for (var i = 0; i < madeToOrder_vendorList.length; i++) {
    const currRecord = madeToOrder_vendorList[i];
    const vendors = currRecord.vendors || [];
    for (var j = 0; j < vendors.length; j++) {
      if (vendors[j] === vendor) {
        if (currRecord.origin === null) return currRecord.defaultValue;
        if (currRecord.origin.hasOwnProperty(origin)) return currRecord.origin[origin];
        return currRecord.defaultValue;
      }
    }
  }
  return madeToOrder_defaultDate;
}
// Returns the in-stock shipping time string for a given vendor
function instockShipCalculation(vendor) {
  vendor = vendor || "";
  for (var i = 0; i < inStockShippingVendorList.length; i++) {
    var vendors = Array.isArray(inStockShippingVendorList[i].vendors) ? inStockShippingVendorList[i].vendors : [];
    if (vendors.indexOf(vendor) >= 0) return inStockShippingVendorList[i].returnString;
  }
  return inStockShippingDefaultDate;
}
// Determines if a pre-order display should be shown based on backorder, vendor, price, and title
function preOrderDisplayCalculation(backOrder, vendor, price, title) {
  // Checks if the product title matches any predefined swatch terms
  function checkIfSwatch() {
    for (var i = 0; i < preOrderDisplay_priceCeilingSwatchTerms.length; i++) {
      if (title.indexOf(preOrderDisplay_priceCeilingSwatchTerms[i]) >= 0) return true;
    }
    return false;
  }
  // Checks if the vendor and price meet criteria and backorder is not excluded
  function checkVendor() {
    for (var i = 0; i < preOrderDisplay_priceCeilingVendorList.length; i++) {
      var vendorEntry = preOrderDisplay_priceCeilingVendorList[i];
      var vendors = vendorEntry.vendors || [];
      for (var j = 0; j < vendors.length; j++) {
        if (vendors[j] === vendor && price < vendorEntry.ceiling) {
          return preOrderDisplay_backOrderExclusions.indexOf(backOrder) < 0;
        }
      }
    }
    return false;
  }
  // Main calculation based on price
  if (price >= 3500) return checkIfSwatch() || checkVendor();
  return false;
}

function getBackOrderValue(currentProduct, currentVariant, currentMetafields) {
  const isEmptyOrEquals = (v, t) => !v || v.toUpperCase() === t.toUpperCase();
  const createPrefix = (p, v, c) => prefixObject(p, v, c, false);
  const backOrder = (currentMetafields && currentMetafields.backorder) ? currentMetafields.backorder : '';
  const tags = Array.isArray(currentProduct.tags) ? currentProduct.tags : [];
  const vendor = currentProduct.vendor || '';
  const quantity = typeof currentVariant.inventory_quantity === 'number' ? currentVariant.inventory_quantity : 0;
  const policy = currentVariant.inventory_policy || '';
  const title = currentVariant.title || '';
  const ship = (v) => `<span style="color:${blue}">Ships in ${v}</span>`;
  const formatStock = (q, v, t) => {
    const shipText = instockShipCalculation(v, t);
    const ship = (txt) => `<span style="color:${blue}">Ships in ${txt}</span>`;
    const hurry = (text, color) => `<span style="color:${color}">Hurry, ${text}</span>`;
    if (q === 1) return { text: hurry("Only 1 Available.", red) + " " + ship(shipText), color: red };
    if (q > 1 && q <= 3) return { text: hurry(`Only ${q} Available.`, yellow) + " " + ship(shipText), color: yellow };
    return { text: `<span style="color:${green}">In Stock.</span> ` + ship(shipText), color: green };
  };
  // ---------------- Vendor overrides ----------------
  if ( vendor === 'Safavieh' && quantity <= 0 && isEmptyOrEquals(policy, 'CONTINUE') && isEmptyOrEquals(backOrder, 'CHAT FOR DATE') ) 
    return createPrefix(backOrder_prefixes.preOrder, 'Ships: 3 - 6 Months', yellow);
  if (vendor === 'Karastan' && title.toLowerCase().includes("custom")) 
    return createPrefix( backOrder_prefixes.madeToOrder, 'Ships in 2 - 4 Weeks', yellow );
  // ---------------- No backorder data ----------------
  if (!backOrder) {
    if (quantity > 0) {
      const s = formatStock(quantity, vendor, tags);
      return createPrefix('', s.text, s.color);
    }
    if (quantity <= 0 && policy === 'continue') return createPrefix(backOrder_prefixes.preOrder, 'Ships: 3 - 6 Months', yellow);
    return createPrefix(backOrder_prefixes.preOrder, 'Chat For Date', yellow);
  }
  // ---------------- Normalization ----------------
  const normalizedBackOrder = getBackorderStatus(backOrder, currentVariant, tags, currentProduct);
  if (!normalizedBackOrder || normalizedBackOrder.trim() === '') 
    return createPrefix(backOrder_prefixes.preOrder, 'Chat For Date', yellow);
  // ---------------- Made to order ----------------
  if (normalizedBackOrder === 'Made To Order') 
    return createPrefix( backOrder_prefixes.madeToOrder, `Ships in ${madeToOrderCalculation(vendor, tags)}`, yellow );
  // ---------------- In stock (normalized path) ----------------
  if (normalizedBackOrder === 'In stock') {
    const s = formatStock(quantity, vendor, tags);
    return createPrefix('', s.text, s.color);
  }
  // ---------------- Sold out ----------------
  if (quantity <= 0 && policy === 'deny') return createPrefix(backOrder_prefixes.soldOut, null, red);
  // ---------------- fallback in-stock ----------------
  if (quantity > 0) {
    const s = formatStock(quantity, vendor, tags);
    return createPrefix('', s.text, s.color);
  }
  // ---------------- date-based backorder ----------------
  if ( isValidDate(normalizedBackOrder) || String(normalizedBackOrder).indexOf('Week') >= 0 )
    return createPrefix( backOrder_prefixes.preOrder, `Ships: ${normalizedBackOrder}`, yellow );
  return createPrefix(backOrder_prefixes.preOrder, 'Chat For Date', yellow);
}

// ******************** CHANGE UI/UX DISPLAYED METAFIELDS ******************** 
// Checks a backorder prefix against a predefined list and returns Reamaze link info
function checkPrefixText(prefixText) {
  if (typeof prefixText !== "string") return { replaceValue: null, replaceText: false };
  var normalizedText = prefixText.replace(/[ \-_]/g, "").toLowerCase().trim();
  for (var i = 0; i < shippingPreFixTextList.length; i++) {
    var item = shippingPreFixTextList[i];
    if (item && typeof item.reamazeLink !== "undefined" && item.prefixCheck === normalizedText) 
      return { replaceValue: item.reamazeLink, replaceText: true };
  }
  return { replaceValue: null, replaceText: false };
}
// Wraps a value with a Reamaze link and icon if applicable
function addReamazeAnchorTag(value, replaceObject) {
  try {
    if (typeof replaceObject === "object" && typeof value === "string") {
      var hasReplaceValue = typeof replaceObject.replaceValue !== "undefined";
      var hasReplaceText = typeof replaceObject.replaceText !== "undefined";
      if (hasReplaceValue && hasReplaceText && replaceObject.replaceText === true) {
        var svgImage = ''
          + '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#b0acac" width="14" height="14">'
          + '<path stroke-linecap="round" stroke-linejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z"/>'
          + '</svg>';
        return '<a target="_blank" data-kb-url="' + replaceObject.replaceValue + '" style="' + reamazeShippingStyle + '">' + value + ' ' + svgImage + '</a>';
      }
    }
    return '<span style="' + reamazeShippingStyle + '">' + value + '</span>';
  } catch (err) { return value; }
}
// Returns shipping text for Made To Order items
function setMadeToOrderShipTime(backOrderPrefix, backOrderValue){
  if (backOrderPrefix === backOrder_prefixes.madeToOrder) return "Ships in 2-3 weeks";
  return backOrderValue;
};
// Updates the backorder display for a product with modular internal functions
function setBackOrderValue(backOrderValues, productId, vendor, policy) {
  // Vendor-specific overrides for backorder text and color
  function getVendorBackOrderText(vendor, policy) {
    var text = null;
    var color = null;
    if (vendor === "Colonial Mills") {
      if (policy !== "deny") {
        text = "2 - 3 months";
        color = linkBlue;
      } else {
        text = "Sold Out";
        color = red;
      }
    }
    return { text: text, color: color };
  }
  // Normalize backorder values
  function normalizeBackOrderValues(values) {
    return { prefix: values.prefix || null, value: values.value || null, color: values.color || grey };
  }
  // Format HTML for backorder display
  function formatBackOrderHTML(prefix, value, color) {
    var labelStyle = 'style="color: ' + color + ' !important"';
    var displayText = "";
    if (prefix && value) displayText = prefix + ". " + addReamazeAnchorTag(value, checkPrefixText(prefix));
    else if (prefix) displayText = prefix;
    else if (value) displayText = addReamazeAnchorTag(value, checkPrefixText(prefix));
    return '<label ' + backOrderLabel_class + '>Availability: <span ' + labelStyle + '>' + displayText + '</span></label>';
  }
  // Update DOM element with HTML
  function updateBackOrderElement(productId, html) {
    var el = document.getElementById("displayBackOrder_" + productId);
    if (el) el.innerHTML = html;
  }
  var element = document.getElementById("displayBackOrder_" + productId);
  if (!element) return;
  var vendorOverride = getVendorBackOrderText(vendor, policy);
  if (vendorOverride.text !== null) {
    updateBackOrderElement(productId, '<label ' + backOrderLabel_class + '>Availability: <span style="color:' 
      + vendorOverride.color + ' !important">' + vendorOverride.text + '</span></label>');
    return;
  }
  var normalizedValues = normalizeBackOrderValues(backOrderValues);
  if (normalizedValues.prefix !== null || normalizedValues.value !== null) {
    var html = formatBackOrderHTML(normalizedValues.prefix, normalizedValues.value, normalizedValues.color);
    updateBackOrderElement(productId, html);
  }
};
// Sets metafields and backorder info for the current variant
function setVariantMetafields_variantChange(variant, pageLoad) {
  var currentVariant = null;
  if (variant === null && pageLoad === true) currentVariant = getVariantOnLoad()  
  else currentVariant = variant;
  if (!currentVariant || !currentVariant.id) return null;
  var currentProduct = findParentId(currentVariant.id);
  if (!currentProduct) return null;
  var currentMetafields = getMetafields(currentVariant.id, currentProduct.id);
  var backOrderValue = getBackOrderValue(currentProduct, currentVariant, currentMetafields);
  setBackOrderValue(backOrderValue, currentProduct.id, currentProduct.vendor, currentVariant.inventory_policy);
  return backOrderValue;
};
// Toggles Notify Me button based on variant availability
function toggleNotifyMe(variant) {
  // Removes the Notify Me button from the DOM but stores it
  function addNotifyMe(btn) {
    btn = btn || document.getElementById(buttonId_notifyMe);
    if (btn && btn.parentNode) {
      notify_storedButton = btn;
      notify_parent = btn.parentNode;
      notify_nextSibling = btn.nextElementSibling;
      notify_parent.removeChild(btn);
    }
  }
  // Restores the previously removed Notify Me button
  function deleteNotifyMe() {
    if (notify_storedButton && notify_parent) {
      notify_parent.insertBefore(notify_storedButton, notify_nextSibling || null);
      notify_storedButton = null;
      notify_parent = null;
      notify_nextSibling = null;
    }
  }
  try {
    var btn = document.getElementById(buttonId_notifyMe);
    if (!btn) return;
    if (variant && variant.available === false) addNotifyMe(btn);
    else if (variant && variant.available === true) deleteNotifyMe();
  } catch (err) { console.error("toggleNotifyMe error:", err.message); }
}


// ******************** CHANGE UI/UX OTHER ******************** 
// Updates Add to Cart button text and color based on variant availability
function setAddToCart_variantChange(variant, valueSet, pageLoad) {
  // Sets the Add to Cart button color based on inventory and policy
  function setButtonColor() {
    var buttonColor = '';
    if (hidePreOrder === false) {
      if (quantity > 0) {
        buttonColor = black;
        if (utilizeAdditionalCartButtonLogic) enableSaleButton(black);
      } else if (quantity <= 0 && policy === "continue") {
        buttonColor = blue;
        if (utilizeAdditionalCartButtonLogic) enableSaleButton(blue);
      } else {
        buttonColor = grey;
        if (utilizeAdditionalCartButtonLogic) disableSaleButton();
      }
    } else {
      buttonColor = grey;
      if (utilizeAdditionalCartButtonLogic) disableSaleButton();
    }
    if (productCartButton) productCartButton.style.backgroundColor = buttonColor;
  }
  // Sets the Add to Cart button text based on inventory and policy
  function setButtonText() {
    var buttonText = '';
    if (quantity > 0) buttonText = cartText_quanityAboveZero;
    else if (quantity <= 0 && policy === "continue") buttonText = cartText_quanityAtOrBelowZeroContinue;
    else buttonText = cartText_quanityAtOrBelowZeroDeny;

    if (productCartButtonSpan) productCartButtonSpan.textContent = buttonText;
  }
  function updateButton() {
    setButtonColor();
    setButtonText();
  }
  if (!variant) {
    if (pageLoad === true) console.log("Load Page");
    return;
  }
  var hidePreOrder = valueSet && valueSet.hidePreorder;
  var quantity = variant.inventory_quantity;
  var policy = variant.inventory_policy;
  var productCartButton = document.getElementById("productCartButton");
  var productCartButtonSpan = document.getElementById("productCartButtonSpan");
  updateButton();
}
function setSizeDisplay_addFreePadLink(variant, pageLoad) {
  if (!variant) return;
  // replace option text with link
  function replaceText(option, text) {
    var closestSampleSize;
    if (option === "Free Premium Pad") 
      return '<a href="' + freePadLinks.premium + '" ' + openNewTab + ' style="' + anchorStyle + '">Free Premium Pad</a>';
    if (option === "Free Pad") 
      return '<a href="' + freePadLinks.standard + '" ' + openNewTab + ' style="' + anchorStyle + '">Free Pad</a>';
    return option;
  }
  // Get the formatted size text
  function getSizeText() {
    var itemSize = variant.option1;
    if (itemSize.indexOf("Free Premium Pad") !== -1) itemSize = itemSize.split("Free Premium Pad").join(replaceText("Free Premium Pad", variant.option1));
    if (itemSize.indexOf("Free Pad") !== -1) itemSize = itemSize.split("Free Pad").join(replaceText("Free Pad", variant.option1));
    return itemSize;
  }
  // Normalize and set HTML
  function setHtml() {
    var normalizeTextDisplayed = function(data) {
      var words = data.toLowerCase().split(" ");
      for (var i = 0; i < words.length; i++) words[i] = words[i].charAt(0).toUpperCase() + words[i].substring(1); 
      return words.join(" ");
    };
    var currentProduct = findParentId(variant.id);
    if (!currentProduct) return;
    var elementInfo = document.getElementById("displayVariantSize_" + currentProduct.id);
    if (!elementInfo) return;
    var sizeText = normalizeTextDisplayed(getSizeText());
    elementInfo.innerHTML = '<label ' + backOrderLabel_class + '>Size: <span style="color: ' + grey + '">' + sizeText + '</span></label>';
  };
  setHtml();
}
// Updates Add to Cart button state and text safely
function addToCart_ButtonChange(variant, cartAction, pageLoad) {
  var addToCartButton = document.getElementById("productCartButton");
  if (!addToCartButton) return;
  if (cartAction === "initialize_cart") {
    var variantSelected = getSelectedVariant();
    if (variantSelected === null) {
      var addToCartText = document.getElementById("productCartButtonSpan");
      addToCartButton.disabled = true;
      if (addToCartText) addToCartText.textContent = cartButtonInitializationValue;
    }
    return;
  }
  if (cartAction === "change_variant") { addToCartButton.disabled = false; }
}
// Shopify variant selection and cart/Notify Me handling
function changeSelectedVariant(variant, pageLoad) {
  if (pageLoad) { instantiateButton(); }
  var valueSet = null;
  if (variant !== null) { valueSet = setVariantMetafields_variantChange(variant, pageLoad); }
  var currentVariant = variant;
  if (valueSet !== null) {
    toggleNotifyMe(currentVariant);
    if (pageLoad) { currentVariant = getVariantOnLoad(); }
    setAddToCart_variantChange(currentVariant, valueSet, pageLoad);
    setSizeDisplay_addFreePadLink(currentVariant, pageLoad);
    if (currentVariant !== null) { addToCart_ButtonChange(currentVariant, "change_variant", pageLoad); } 
    else { addToCart_ButtonChange(null, "initialize_cart", pageLoad); }
  } else if (pageLoad) {
    setAddToCart_variantChange(currentVariant, valueSet, pageLoad);
    addToCart_ButtonChange(null, "initialize_cart", pageLoad);
  }
}
// ******************** EVENT LISTENERS AND PAGE INITIALIZATION ******************** 
// Variant Data Retrieval
function retrieveVariants() {
  try {
    var el = document.querySelector('div[id^="variantchange_productData"]');
    if (!el) throw new Error("Variant data element not found: div[id^='variantchange_productData']");
    var data = el.innerText;
    if (!data) throw new Error("Variant data is empty");
    return JSON.parse(data);
  } catch (err) {
    console.error("retrieveVariants failed:", err);
    return { variants: [] };
  }
}
// Get Current Variant
function getCurrentVariantData() {
  var search = window.location.search;
  var searchVariantId = null;
  if (search.indexOf("?variant=") === 0) searchVariantId = parseInt(search.replace("?variant=", ""), 10); 
  if (isNaN(searchVariantId)) return null;
  var variants = (retrieveVariants() && retrieveVariants().variants) || [];
  for (var i = 0; i < variants.length; i++) {
    if (parseInt(variants[i].id, 10) === searchVariantId) {
      try { toggleNotifyMe(variants[i]); } 
      catch (err) { console.error("toggleNotifyMe failed:", err); }
      return variants[i];
    }
  }
  return null;
}
// Get Variants Count
function getVariantsCount() {
  try {
    var records = retrieveVariants();
    return (records && records.variants && records.variants.length) || 0;
  } catch (err) {
    console.error("getVariantsCount failed:", err);
    return 0;
  }
}
// Initialize Variant Selection
function initializeVariantSelection() {
  try {
    var currentVariant = getCurrentVariantData();
    // Update cart button text for unavailable variant
    function handleUnavailableVariant(variant) {
      if (variant && variant.available === false) {
        var productCartButtonSpan = document.getElementById("productCartButtonSpan");
        if (productCartButtonSpan) productCartButtonSpan.textContent = cartText_quanityAtOrBelowZeroDeny;
      }
    }
    // Update cart button state and color for single variant
    function handleSingleVariant(records) {
      if (!records || records.length === 0) return;
      var policy = records[0].inventory_policy;
      var quantity = records[0].inventory_quantity;
      var buttonColor;
      var productCartButton = document.getElementById("productCartButton");
      if (quantity > 0) {
        buttonColor = black;
        if (utilizeAdditionalCartButtonLogic && productCartButton) productCartButton.disabled = false;
      } else if (quantity <= 0 && policy === "continue") {
        buttonColor = blue;
        if (utilizeAdditionalCartButtonLogic && productCartButton) productCartButton.disabled = false;
      }
    }
    // Main logic
    handleUnavailableVariant(currentVariant);
    var variantsCount = getVariantsCount();
    if (variantsCount > 1) changeSelectedVariant(null, true); 
    else {
      var records = (retrieveVariants() && retrieveVariants().variants) || [];
      handleSingleVariant(records);
    }
  } catch (err) {
    console.error("initializeVariantSelection failed:", err);
  }
}
// MutationObserver for Notify Button
var notifyButtonObserver = new MutationObserver(function () {
  try {
    var search = window.location.search;
    var searchVariantId = null;
    if (search.indexOf("?variant=") === 0) searchVariantId = parseInt(search.replace("?variant=", ""), 10);
    var btn = document.getElementById(buttonId_notifyMe);
    if (!btn) return;
    var variant = getCurrentVariantData();
    if (!isNaN(searchVariantId)) toggleNotifyMe(variant);  
    else addNotifyMe();
    notifyButtonObserver.disconnect();
  } catch (err) {
    console.error("NotifyButtonObserver failed:", err);
  }
});
notifyButtonObserver.observe(document.body, { childList: true, subtree: true });
// Variant Change Event
document.addEventListener("product:variant-change", function (evt) {
  if (evt && evt.detail && evt.detail.variant) changeSelectedVariant(evt.detail.variant, false);
});

function runVariantSelection(context, runFunction) {
    try {
      var records = getCurrentVariantData();
      if (records) changeSelectedVariant(records, false);
      else {
        var variantsCount = getVariantsCount();
        instantiateButton();
        if(variantsCount > 0){
          var records = retrieveVariants();
          toggleNotifyMe(records[0]);
        }
        console.log(variantsCount, "VARIANT COUNT");
        // initiateNotifyMeButton();
      } 
    } catch (err) { console.error(context + " failed:", err); }
  }

// DOMContentLoaded / Load Fallback
document.addEventListener("DOMContentLoaded", function () {
  var el = document.querySelector('.product-form__item.product-form__item--submit');
  if (el) runVariantSelection("DOMContentLoaded"); 
  else window.addEventListener("load", function () { runVariantSelection("Load Fallback") });
});